"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.fromNFTRaw = exports.toNFTRaw = exports.toAccountRaw = exports.fromAccountRaw = exports.toAccountLikeRaw = exports.fromAccountLikeRaw = exports.toSubAccountRaw = exports.fromSubAccountRaw = exports.toChildAccountRaw = exports.fromChildAccountRaw = exports.toTokenAccountRaw = exports.fromTokenAccountRaw = exports.toSwapOperationRaw = exports.fromSwapOperationRaw = exports.fromOperationRaw = exports.inferSubOperations = exports.toOperationRaw = exports.fromBalanceHistoryRaw = exports.toBalanceHistoryRaw = exports.fromCeloResourcesRaw = exports.toCeloResourcesRaw = exports.fromSolanaResourcesRaw = exports.toSolanaResourcesRaw = exports.fromCardanoResourceRaw = exports.toCardanoResourceRaw = exports.fromCryptoOrgResourcesRaw = exports.toCryptoOrgResourcesRaw = exports.fromElrondResourcesRaw = exports.toElrondResourcesRaw = exports.fromTezosResourcesRaw = exports.toTezosResourcesRaw = exports.fromPolkadotResourcesRaw = exports.toPolkadotResourcesRaw = exports.fromBitcoinResourcesRaw = exports.toBitcoinResourcesRaw = exports.fromCosmosResourcesRaw = exports.toCosmosResourcesRaw = void 0;
var bignumber_js_1 = require("bignumber.js");
var serialization_1 = require("../families/bitcoin/serialization");
exports.toBitcoinResourcesRaw = serialization_1.toBitcoinResourcesRaw;
exports.fromBitcoinResourcesRaw = serialization_1.fromBitcoinResourcesRaw;
var serialization_2 = require("../families/cosmos/serialization");
exports.toCosmosResourcesRaw = serialization_2.toCosmosResourcesRaw;
exports.fromCosmosResourcesRaw = serialization_2.fromCosmosResourcesRaw;
var serialization_3 = require("@ledgerhq/coin-polkadot/serialization");
exports.toPolkadotResourcesRaw = serialization_3.toPolkadotResourcesRaw;
exports.fromPolkadotResourcesRaw = serialization_3.fromPolkadotResourcesRaw;
var serialization_4 = require("../families/tezos/serialization");
exports.toTezosResourcesRaw = serialization_4.toTezosResourcesRaw;
exports.fromTezosResourcesRaw = serialization_4.fromTezosResourcesRaw;
var serialization_5 = require("../families/elrond/serialization");
exports.toElrondResourcesRaw = serialization_5.toElrondResourcesRaw;
exports.fromElrondResourcesRaw = serialization_5.fromElrondResourcesRaw;
var serialization_6 = require("../families/crypto_org/serialization");
exports.toCryptoOrgResourcesRaw = serialization_6.toCryptoOrgResourcesRaw;
exports.fromCryptoOrgResourcesRaw = serialization_6.fromCryptoOrgResourcesRaw;
var serialization_7 = require("../families/solana/serialization");
exports.toSolanaResourcesRaw = serialization_7.toSolanaResourcesRaw;
exports.fromSolanaResourcesRaw = serialization_7.fromSolanaResourcesRaw;
var serialization_8 = require("../families/celo/serialization");
exports.toCeloResourcesRaw = serialization_8.toCeloResourcesRaw;
exports.fromCeloResourcesRaw = serialization_8.fromCeloResourcesRaw;
var currencies_1 = require("../currencies");
var index_1 = require("./index");
var account_1 = __importDefault(require("../generated/account"));
var helpers_1 = require("./helpers");
var balanceHistoryCache_1 = require("@ledgerhq/coin-framework/account/balanceHistoryCache");
var serialization_9 = require("../families/cardano/serialization");
exports.fromCardanoResourceRaw = serialization_9.fromCardanoResourceRaw;
exports.toCardanoResourceRaw = serialization_9.toCardanoResourceRaw;
var serialization_10 = require("@ledgerhq/coin-framework/account/serialization");
var bridge_1 = require("../bridge");
function toBalanceHistoryRaw(b) {
    return b.map(function (_a) {
        var date = _a.date, value = _a.value;
        return [date.toISOString(), value.toString()];
    });
}
exports.toBalanceHistoryRaw = toBalanceHistoryRaw;
function fromBalanceHistoryRaw(b) {
    return b.map(function (_a) {
        var _b = __read(_a, 2), date = _b[0], value = _b[1];
        return ({
            date: new Date(date),
            value: parseFloat(value)
        });
    });
}
exports.fromBalanceHistoryRaw = fromBalanceHistoryRaw;
var toOperationRaw = function (operation, preserveSubOperation) {
    var copy = (0, serialization_10.toOperationRaw)(operation, preserveSubOperation);
    var e = copy.extra;
    if (e) {
        var family = (0, index_1.inferFamilyFromAccountId)(copy.accountId);
        if (family) {
            var abf = account_1["default"][family];
            if (abf && abf.toOperationExtraRaw) {
                e = abf.toOperationExtraRaw(e);
            }
        }
    }
    return __assign(__assign({}, copy), { extra: e });
};
exports.toOperationRaw = toOperationRaw;
var serialization_11 = require("@ledgerhq/coin-framework/account/serialization");
__createBinding(exports, serialization_11, "inferSubOperations");
var fromOperationRaw = function (operation, accountId, subAccounts) {
    var res = (0, serialization_10.fromOperationRaw)(operation, accountId, subAccounts);
    var e = res.extra;
    if (e) {
        var family = (0, index_1.inferFamilyFromAccountId)(res.accountId);
        if (family) {
            var abf = account_1["default"][family];
            if (abf && abf.fromOperationExtraRaw) {
                e = abf.fromOperationExtraRaw(e);
            }
        }
    }
    return __assign(__assign({}, res), { extra: e || {} });
};
exports.fromOperationRaw = fromOperationRaw;
function fromSwapOperationRaw(raw) {
    var fromAmount = raw.fromAmount, toAmount = raw.toAmount;
    return __assign(__assign({}, raw), { fromAmount: new bignumber_js_1.BigNumber(fromAmount), toAmount: new bignumber_js_1.BigNumber(toAmount) });
}
exports.fromSwapOperationRaw = fromSwapOperationRaw;
function toSwapOperationRaw(so) {
    var fromAmount = so.fromAmount, toAmount = so.toAmount;
    return __assign(__assign({}, so), { fromAmount: fromAmount.toString(), toAmount: toAmount.toString() });
}
exports.toSwapOperationRaw = toSwapOperationRaw;
function fromTokenAccountRaw(raw) {
    var id = raw.id, parentId = raw.parentId, tokenId = raw.tokenId, starred = raw.starred, operations = raw.operations, pendingOperations = raw.pendingOperations, creationDate = raw.creationDate, balance = raw.balance, spendableBalance = raw.spendableBalance, compoundBalance = raw.compoundBalance, balanceHistoryCache = raw.balanceHistoryCache, swapHistory = raw.swapHistory, approvals = raw.approvals;
    var token = (0, currencies_1.getTokenById)(tokenId);
    var convertOperation = function (op) { return (0, exports.fromOperationRaw)(op, id); };
    var res = {
        type: "TokenAccount",
        id: id,
        parentId: parentId,
        token: token,
        starred: starred || false,
        balance: new bignumber_js_1.BigNumber(balance),
        spendableBalance: spendableBalance
            ? new bignumber_js_1.BigNumber(spendableBalance)
            : new bignumber_js_1.BigNumber(balance),
        compoundBalance: compoundBalance
            ? new bignumber_js_1.BigNumber(compoundBalance)
            : undefined,
        creationDate: new Date(creationDate || Date.now()),
        operationsCount: raw.operationsCount || (operations && operations.length) || 0,
        operations: (operations || []).map(convertOperation),
        pendingOperations: (pendingOperations || []).map(convertOperation),
        swapHistory: (swapHistory || []).map(fromSwapOperationRaw),
        approvals: approvals,
        balanceHistoryCache: balanceHistoryCache || balanceHistoryCache_1.emptyHistoryCache
    };
    res.balanceHistoryCache = (0, balanceHistoryCache_1.generateHistoryFromOperations)(res);
    return res;
}
exports.fromTokenAccountRaw = fromTokenAccountRaw;
function toTokenAccountRaw(ta) {
    var id = ta.id, parentId = ta.parentId, token = ta.token, starred = ta.starred, operations = ta.operations, operationsCount = ta.operationsCount, pendingOperations = ta.pendingOperations, balance = ta.balance, spendableBalance = ta.spendableBalance, compoundBalance = ta.compoundBalance, balanceHistoryCache = ta.balanceHistoryCache, swapHistory = ta.swapHistory, approvals = ta.approvals;
    return {
        type: "TokenAccountRaw",
        id: id,
        parentId: parentId,
        starred: starred,
        tokenId: token.id,
        balance: balance.toString(),
        spendableBalance: spendableBalance.toString(),
        compoundBalance: compoundBalance ? compoundBalance.toString() : undefined,
        balanceHistoryCache: balanceHistoryCache,
        creationDate: ta.creationDate.toISOString(),
        operationsCount: operationsCount,
        operations: operations.map(function (o) { return (0, exports.toOperationRaw)(o); }),
        pendingOperations: pendingOperations.map(function (o) { return (0, exports.toOperationRaw)(o); }),
        swapHistory: (swapHistory || []).map(toSwapOperationRaw),
        approvals: approvals
    };
}
exports.toTokenAccountRaw = toTokenAccountRaw;
function fromChildAccountRaw(raw) {
    var id = raw.id, name = raw.name, parentId = raw.parentId, currencyId = raw.currencyId, starred = raw.starred, creationDate = raw.creationDate, operations = raw.operations, operationsCount = raw.operationsCount, pendingOperations = raw.pendingOperations, balance = raw.balance, address = raw.address, balanceHistoryCache = raw.balanceHistoryCache, swapHistory = raw.swapHistory;
    var currency = (0, currencies_1.getCryptoCurrencyById)(currencyId);
    var convertOperation = function (op) { return (0, exports.fromOperationRaw)(op, id); };
    var res = {
        type: "ChildAccount",
        id: id,
        name: name,
        starred: starred || false,
        parentId: parentId,
        currency: currency,
        address: address,
        balance: new bignumber_js_1.BigNumber(balance),
        creationDate: new Date(creationDate || Date.now()),
        operationsCount: operationsCount || (operations && operations.length) || 0,
        operations: (operations || []).map(convertOperation),
        pendingOperations: (pendingOperations || []).map(convertOperation),
        swapHistory: (swapHistory || []).map(fromSwapOperationRaw),
        balanceHistoryCache: balanceHistoryCache || balanceHistoryCache_1.emptyHistoryCache
    };
    res.balanceHistoryCache = (0, balanceHistoryCache_1.generateHistoryFromOperations)(res);
    return res;
}
exports.fromChildAccountRaw = fromChildAccountRaw;
function toChildAccountRaw(ca) {
    var id = ca.id, name = ca.name, parentId = ca.parentId, starred = ca.starred, currency = ca.currency, operations = ca.operations, operationsCount = ca.operationsCount, pendingOperations = ca.pendingOperations, balance = ca.balance, balanceHistoryCache = ca.balanceHistoryCache, address = ca.address, creationDate = ca.creationDate, swapHistory = ca.swapHistory;
    return {
        type: "ChildAccountRaw",
        id: id,
        name: name,
        starred: starred,
        parentId: parentId,
        address: address,
        operationsCount: operationsCount,
        currencyId: currency.id,
        balance: balance.toString(),
        balanceHistoryCache: balanceHistoryCache,
        creationDate: creationDate.toISOString(),
        operations: operations.map(function (o) { return (0, exports.toOperationRaw)(o); }),
        pendingOperations: pendingOperations.map(function (o) { return (0, exports.toOperationRaw)(o); }),
        swapHistory: (swapHistory || []).map(toSwapOperationRaw)
    };
}
exports.toChildAccountRaw = toChildAccountRaw;
function fromSubAccountRaw(raw) {
    switch (raw.type) {
        case "ChildAccountRaw":
            return fromChildAccountRaw(raw);
        case "TokenAccountRaw":
            return fromTokenAccountRaw(raw);
        default:
            throw new Error("invalid raw.type=" + raw.type);
    }
}
exports.fromSubAccountRaw = fromSubAccountRaw;
function toSubAccountRaw(subAccount) {
    switch (subAccount.type) {
        case "ChildAccount":
            return toChildAccountRaw(subAccount);
        case "TokenAccount":
            return toTokenAccountRaw(subAccount);
        default:
            throw new Error("invalid subAccount.type=" + subAccount.type);
    }
}
exports.toSubAccountRaw = toSubAccountRaw;
function fromAccountLikeRaw(rawAccountLike) {
    if ("type" in rawAccountLike) {
        //$FlowFixMe
        return fromSubAccountRaw(rawAccountLike);
    }
    //$FlowFixMe
    return fromAccountRaw(rawAccountLike);
}
exports.fromAccountLikeRaw = fromAccountLikeRaw;
function toAccountLikeRaw(accountLike) {
    switch (accountLike.type) {
        case "Account":
            return toAccountRaw(accountLike);
        default:
            return toSubAccountRaw(accountLike);
    }
}
exports.toAccountLikeRaw = toAccountLikeRaw;
function fromAccountRaw(rawAccount) {
    var id = rawAccount.id, seedIdentifier = rawAccount.seedIdentifier, derivationMode = rawAccount.derivationMode, index = rawAccount.index, xpub = rawAccount.xpub, starred = rawAccount.starred, used = rawAccount.used, freshAddress = rawAccount.freshAddress, freshAddressPath = rawAccount.freshAddressPath, freshAddresses = rawAccount.freshAddresses, name = rawAccount.name, blockHeight = rawAccount.blockHeight, endpointConfig = rawAccount.endpointConfig, currencyId = rawAccount.currencyId, unitMagnitude = rawAccount.unitMagnitude, operations = rawAccount.operations, operationsCount = rawAccount.operationsCount, pendingOperations = rawAccount.pendingOperations, lastSyncDate = rawAccount.lastSyncDate, creationDate = rawAccount.creationDate, balance = rawAccount.balance, balanceHistoryCache = rawAccount.balanceHistoryCache, spendableBalance = rawAccount.spendableBalance, subAccountsRaw = rawAccount.subAccounts, swapHistory = rawAccount.swapHistory, syncHash = rawAccount.syncHash, nfts = rawAccount.nfts;
    var subAccounts = subAccountsRaw &&
        subAccountsRaw
            .map(function (ta) {
            if (ta.type === "TokenAccountRaw") {
                if ((0, currencies_1.findTokenById)(ta.tokenId)) {
                    return fromTokenAccountRaw(ta);
                }
            }
            else {
                return fromSubAccountRaw(ta);
            }
        })
            .filter(Boolean);
    var currency = (0, currencies_1.getCryptoCurrencyById)(currencyId);
    var unit = currency.units.find(function (u) { return u.magnitude === unitMagnitude; }) ||
        currency.units[0];
    var convertOperation = function (op) {
        return (0, exports.fromOperationRaw)(op, id, subAccounts);
    };
    var res = {
        type: "Account",
        id: id,
        starred: starred || false,
        used: false,
        // filled again below
        seedIdentifier: seedIdentifier,
        derivationMode: derivationMode,
        index: index,
        freshAddress: freshAddress,
        freshAddressPath: freshAddressPath,
        freshAddresses: freshAddresses || [
            // in case user come from an old data that didn't support freshAddresses
            {
                derivationPath: freshAddressPath,
                address: freshAddress
            },
        ],
        name: name,
        blockHeight: blockHeight,
        creationDate: new Date(creationDate || Date.now()),
        balance: new bignumber_js_1.BigNumber(balance),
        spendableBalance: new bignumber_js_1.BigNumber(spendableBalance || balance),
        operations: (operations || []).map(convertOperation),
        operationsCount: operationsCount || (operations && operations.length) || 0,
        pendingOperations: (pendingOperations || []).map(convertOperation),
        unit: unit,
        currency: currency,
        lastSyncDate: new Date(lastSyncDate || 0),
        swapHistory: [],
        syncHash: syncHash,
        balanceHistoryCache: balanceHistoryCache || balanceHistoryCache_1.emptyHistoryCache,
        nfts: nfts === null || nfts === void 0 ? void 0 : nfts.map(function (n) { return fromNFTRaw(n); })
    };
    res.balanceHistoryCache = (0, balanceHistoryCache_1.generateHistoryFromOperations)(res);
    if (typeof used === "undefined") {
        // old account data that didn't had the field yet
        res.used = !(0, helpers_1.isAccountEmpty)(res);
    }
    else {
        res.used = used;
    }
    if (xpub) {
        res.xpub = xpub;
    }
    if (endpointConfig) {
        res.endpointConfig = endpointConfig;
    }
    if (subAccounts) {
        res.subAccounts = subAccounts;
    }
    switch (res.currency.family) {
        case "cosmos": {
            var cosmosResourcesRaw = rawAccount
                .cosmosResources;
            if (cosmosResourcesRaw)
                res.cosmosResources =
                    (0, serialization_2.fromCosmosResourcesRaw)(cosmosResourcesRaw);
            break;
        }
        case "tezos": {
            var tezosResourcesRaw = rawAccount.tezosResources;
            if (tezosResourcesRaw)
                res.tezosResources =
                    (0, serialization_4.fromTezosResourcesRaw)(tezosResourcesRaw);
            break;
        }
        case "bitcoin": {
            var bitcoinResourcesRaw = rawAccount
                .bitcoinResources;
            if (bitcoinResourcesRaw)
                res.bitcoinResources =
                    (0, serialization_1.fromBitcoinResourcesRaw)(bitcoinResourcesRaw);
            break;
        }
        case "polkadot": {
            var polkadotResourcesRaw = rawAccount
                .polkadotResources;
            if (polkadotResourcesRaw)
                res.polkadotResources =
                    (0, serialization_3.fromPolkadotResourcesRaw)(polkadotResourcesRaw);
            break;
        }
        case "elrond": {
            var elrondResourcesRaw = rawAccount
                .elrondResources;
            if (elrondResourcesRaw)
                res.elrondResources =
                    (0, serialization_5.fromElrondResourcesRaw)(elrondResourcesRaw);
            break;
        }
        case "solana": {
            var solanaResourcesRaw = rawAccount
                .solanaResources;
            if (solanaResourcesRaw)
                res.solanaResources =
                    (0, serialization_7.fromSolanaResourcesRaw)(solanaResourcesRaw);
            break;
        }
        case "crypto_org": {
            var cryptoOrgResourcesRaw = rawAccount
                .cryptoOrgResources;
            if (cryptoOrgResourcesRaw)
                res.cryptoOrgResources =
                    (0, serialization_6.fromCryptoOrgResourcesRaw)(cryptoOrgResourcesRaw);
            break;
        }
        case "celo": {
            var celoResourcesRaw = rawAccount.celoResources;
            if (celoResourcesRaw)
                res.celoResources =
                    (0, serialization_8.fromCeloResourcesRaw)(celoResourcesRaw);
            break;
        }
        default: {
            var bridge = (0, bridge_1.getAccountBridge)(res);
            var assignFromAccountRaw = bridge.assignFromAccountRaw;
            if (assignFromAccountRaw) {
                assignFromAccountRaw(rawAccount, res);
            }
        }
    }
    if (swapHistory) {
        res.swapHistory = swapHistory.map(fromSwapOperationRaw);
    }
    return res;
}
exports.fromAccountRaw = fromAccountRaw;
function toAccountRaw(account) {
    var id = account.id, seedIdentifier = account.seedIdentifier, xpub = account.xpub, name = account.name, starred = account.starred, used = account.used, derivationMode = account.derivationMode, index = account.index, freshAddress = account.freshAddress, freshAddressPath = account.freshAddressPath, freshAddresses = account.freshAddresses, blockHeight = account.blockHeight, currency = account.currency, creationDate = account.creationDate, operationsCount = account.operationsCount, operations = account.operations, pendingOperations = account.pendingOperations, unit = account.unit, lastSyncDate = account.lastSyncDate, balance = account.balance, balanceHistoryCache = account.balanceHistoryCache, spendableBalance = account.spendableBalance, subAccounts = account.subAccounts, endpointConfig = account.endpointConfig, swapHistory = account.swapHistory, syncHash = account.syncHash, nfts = account.nfts;
    var res = {
        id: id,
        seedIdentifier: seedIdentifier,
        name: name,
        starred: starred,
        used: used,
        derivationMode: derivationMode,
        index: index,
        freshAddress: freshAddress,
        freshAddressPath: freshAddressPath,
        freshAddresses: freshAddresses,
        blockHeight: blockHeight,
        syncHash: syncHash,
        creationDate: creationDate.toISOString(),
        operationsCount: operationsCount,
        operations: (operations || []).map(function (o) { return (0, exports.toOperationRaw)(o); }),
        pendingOperations: (pendingOperations || []).map(function (o) { return (0, exports.toOperationRaw)(o); }),
        currencyId: currency.id,
        unitMagnitude: unit.magnitude,
        lastSyncDate: lastSyncDate.toISOString(),
        balance: balance.toFixed(),
        spendableBalance: spendableBalance.toFixed(),
        nfts: nfts === null || nfts === void 0 ? void 0 : nfts.map(function (n) { return toNFTRaw(n); })
    };
    if (balanceHistoryCache) {
        res.balanceHistoryCache = balanceHistoryCache;
    }
    if (endpointConfig) {
        res.endpointConfig = endpointConfig;
    }
    if (xpub) {
        res.xpub = xpub;
    }
    if (subAccounts) {
        res.subAccounts = subAccounts.map(toSubAccountRaw);
    }
    switch (account.currency.family) {
        case "cosmos": {
            var cosmosAccount = account;
            if (cosmosAccount.cosmosResources) {
                res.cosmosResources = (0, serialization_2.toCosmosResourcesRaw)(cosmosAccount.cosmosResources);
            }
            break;
        }
        case "tezos": {
            var tezosAccount = account;
            if (tezosAccount.tezosResources) {
                res.tezosResources = (0, serialization_4.toTezosResourcesRaw)(tezosAccount.tezosResources);
            }
            break;
        }
        case "bitcoin": {
            var bitcoinAccount = account;
            if (bitcoinAccount.bitcoinResources) {
                res.bitcoinResources = (0, serialization_1.toBitcoinResourcesRaw)(bitcoinAccount.bitcoinResources);
            }
            break;
        }
        case "polkadot": {
            var polkadotAccount = account;
            if (polkadotAccount.polkadotResources) {
                res.polkadotResources = (0, serialization_3.toPolkadotResourcesRaw)(polkadotAccount.polkadotResources);
            }
            break;
        }
        case "elrond": {
            var elrondAccount = account;
            if (elrondAccount.elrondResources) {
                res.elrondResources = (0, serialization_5.toElrondResourcesRaw)(elrondAccount.elrondResources);
            }
            break;
        }
        case "solana": {
            var solanaAccount = account;
            if (solanaAccount.solanaResources) {
                res.solanaResources = (0, serialization_7.toSolanaResourcesRaw)(solanaAccount.solanaResources);
            }
            break;
        }
        case "crypto_org": {
            var crytpoOrgAccount = account;
            if (crytpoOrgAccount.cryptoOrgResources) {
                res.cryptoOrgResources =
                    (0, serialization_6.toCryptoOrgResourcesRaw)(crytpoOrgAccount.cryptoOrgResources);
            }
            break;
        }
        case "celo": {
            var celoAccount = account;
            if (celoAccount.celoResources)
                res.celoResources = (0, serialization_8.toCeloResourcesRaw)(celoAccount.celoResources);
            break;
        }
        default: {
            var bridge = (0, bridge_1.getAccountBridge)(account);
            var assignToAccountRaw = bridge.assignToAccountRaw;
            if (assignToAccountRaw) {
                assignToAccountRaw(account, res);
            }
        }
    }
    if (swapHistory) {
        res.swapHistory = swapHistory.map(toSwapOperationRaw);
    }
    return res;
}
exports.toAccountRaw = toAccountRaw;
function toNFTRaw(_a) {
    var id = _a.id, tokenId = _a.tokenId, amount = _a.amount, contract = _a.contract, standard = _a.standard, currencyId = _a.currencyId, metadata = _a.metadata;
    return {
        id: id,
        tokenId: tokenId,
        amount: amount.toFixed(),
        contract: contract,
        standard: standard,
        currencyId: currencyId,
        metadata: metadata
    };
}
exports.toNFTRaw = toNFTRaw;
function fromNFTRaw(_a) {
    var id = _a.id, tokenId = _a.tokenId, amount = _a.amount, contract = _a.contract, standard = _a.standard, currencyId = _a.currencyId, metadata = _a.metadata;
    return {
        id: id,
        tokenId: tokenId,
        amount: new bignumber_js_1.BigNumber(amount),
        contract: contract,
        standard: standard,
        currencyId: currencyId,
        metadata: metadata
    };
}
exports.fromNFTRaw = fromNFTRaw;
//# sourceMappingURL=serialization.js.map